import CoreAPI from "./coreAPI";
import { mockEmployerSearchResponse } from "./mockAPIResponse";

export type FetchEmployerListResponse = {
  employerId: string;
  employerName: string;
  employerCity: string | null;
  employerState: string | null;
  numberOfParticipants: number;
}[];

const APIEmployer = (coreAPI: CoreAPI) => {
  return {
    async fetchEmployersList(employerName = ""): Promise<FetchEmployerListResponse> {
      if (process.env.REACT_APP_ENV === "local") {
        return mockEmployerSearchResponse;
      }
      return coreAPI.call({
        method: "GET",
        url: `/employers?nameContains=${employerName}`,
      });
    },
    async findProviderByEmployerId(employerId = ""): Promise<string[]> {
      if (process.env.REACT_APP_ENV === "local") {
        return ["TIAA"];
      }
      return coreAPI.call({
        method: "GET",
        url: `/providersByEmployerId?employerId=${employerId}`,
      });
    },
  };
};

export default APIEmployer;
